import './../css/main.css';
import Alpine from 'alpinejs'

import './blocks/hero-home'
import './blocks/stations'
import './blocks/partners'

window.Alpine = Alpine
Alpine.start()
